export const home = {
  // Navigation
  'nav.home': 'ホーム',
  'nav.services': '事業内容',
  'nav.about': '私たちについて',
  'nav.contact': 'お問い合わせ',
  'nav.cta': '無料相談する',

  // Hero
  'hero.badge': '仙台のクリエイティブパートナー',
  'hero.title1': 'Webもデザインも',
  'hero.title2': '事務作業も',
  'hero.title3': '全部お任せください',
  'hero.subtitle': 'ヴェリテは仙台市青葉区を拠点とする、Web制作・デザイン印刷・動画制作・BPO事務サポートの総合クリエイティブカンパニーです。地域の中小企業にとって、気軽に頼れる制作パートナーとして活動しています。',
  'hero.cta.primary': '無料相談はこちら',
  'hero.cta.secondary': '事業内容を見る',

  // Services
  'services.sectionTitle': '4つの事業',
  'services.sectionSubtitle': '事業内容',
  'services.web.title': 'Web制作',
  'services.web.desc': 'ホームページやLPの制作からスマホ対応、更新代行、保守管理まで。HTML/CSS/JSを使った丁寧なコーディングで、あなたのビジネスに最適なWebサイトを作ります。',
  'services.design.title': 'デザイン・印刷',
  'services.design.desc': 'ロゴ、チラシ、名刺、SNS画像、ポスター、パンフレットなど。デザインから印刷発注までワンストップで対応。プロのデザイナーがブランドの魅力を引き出します。',
  'services.video.title': '動画制作',
  'services.video.desc': 'SNS向けの短尺動画制作。TikTok、Instagram Reels、YouTube Shortsなど、トレンドに合わせた縦型・横型動画を制作。視聴者の心を掴む演出で差別化を図ります。',
  'services.bpo.title': 'BPO・事務サポート',
  'services.bpo.desc': 'データ入力や書類スキャンなどの事務作業を代行。中小企業の煩雑な業務を肩代わりし、本業に集中できる環境を作ります。',

  // BPO Feature
  'bpo.badge': '最大の特徴',
  'bpo.title': '就労支援と連携したBPO',
  'bpo.subtitle': 'ビジネスと社会貢献、両方叶える新しい働き方',
  'bpo.desc': 'フライズグループは障がい者支援・就労継続支援の事業も展開しています。ヴェリテはその仕組みを活かして、事務作業を就労支援の参加者と分担して実施します。',
  'bpo.item1.title': 'データ入力・書類整理',
  'bpo.item1.desc': '就労支援の参加者が担当。丁寧な作業で品質を担保します。',
  'bpo.item2.title': '品質管理・窓口対応',
  'bpo.item2.desc': 'ヴェリテが一貫して担当。安心してアウトソースできます。',
  'bpo.item3.title': '二重の価値',
  'bpo.item3.desc': '事務作業をアウトソースできる上に、社会貢献にも繋がります。',
  'bpo.cta': 'BPOサービスの詳細を見る',

  // Strengths
  'strengths.sectionTitle': '選ばれる理由',
  'strengths.sectionSubtitle': 'ヴェリテの強み',
  'strengths.item1.title': 'フライズグループの安心感',
  'strengths.item1.desc': '福祉・就労支援に取り組むフライズグループの一員として、社会的責任を持った運営をしています。信頼できるパートナーとして長くお付き合いいただけます。',
  'strengths.item2.title': '仙台の窓口が一括対応',
  'strengths.item2.desc': '制作から保守管理まで、仙台のチームが一貫して対応。遠方の業者に依頼する必要がなく、打ち合わせもスムーズです。',
  'strengths.item3.title': 'わかりやすい料金体系',
  'strengths.item3.desc': '追加料金の心配がない明朗会計。中小企業にとって予算を立てやすい、わかりやすい価格設定です。',
  'strengths.item4.title': '地域に根ざした対応',
  'strengths.item4.desc': '仙台・宮城県の中小企業を主な対象とし、地域の事情や文化を理解した丁寧な対応を心がけています。',

  // CTA
  'cta.title': 'まずは気軽に相談してみませんか？',
  'cta.subtitle': 'Web制作、デザイン、動画、事務作業の代行...どんな小さな悩みでも大丈夫。仙台のパートナーとして、一緒に解決策を探します。',
  'cta.button': '無料相談はこちら',
  'cta.note': '初回相談は完全無料。ご不明点なんでもお気軽にどうぞ。',

  // Contact Form
  'form.title': 'お問い合わせ',
  'form.name': 'お名前',
  'form.namePlaceholder': '山田 太郎',
  'form.company': '会社名',
  'form.companyPlaceholder': '株式会社〇〇',
  'form.email': 'メールアドレス',
  'form.emailPlaceholder': 'your@email.com',
  'form.phone': '電話番号',
  'form.phonePlaceholder': '022-000-0000',
  'form.service': 'ご希望のサービス',
  'form.service.web': 'Web制作',
  'form.service.design': 'デザイン・印刷',
  'form.service.video': '動画制作',
  'form.service.bpo': 'BPO・事務サポート',
  'form.service.other': 'その他・相談',
  'form.message': 'お問い合わせ内容',
  'form.messagePlaceholder': 'お困りのことやご希望をお聞かせください...',
  'form.submit': '送信する',
  'form.sending': '送信中...',
  'form.success': 'お問い合わせありがとうございます。担当者より数日以内にご連絡いたします。',
  'form.error': '送信に失敗しました。時間を置いて再度お試しください。',

  // Footer
  'footer.company': 'ヴェリテ株式会社',
  'footer.companyDesc': '仙台市青葉区を拠点とするクリエイティブ制作・BPO支援会社。フライズグループの一員として、地域の中小企業をサポートしています。',
  'footer.group': 'フライズグループ',
  'footer.groupDesc': '地域で福祉・就労支援に取り組むグループ。ヴェリテはその一員として社会的価値の創造に貢献しています。',
  'footer.address': '宮城県仙台市青葉区',
  'footer.links.title': 'リンク',
  'footer.links.home': 'ホーム',
  'footer.links.services': '事業内容',
  'footer.links.about': '私たちについて',
  'footer.links.contact': 'お問い合わせ',
  'footer.copyright': '© 2026 VERITE Inc. All rights reserved.',
};

export default home;